import { createContext, useContext } from 'react';

export enum Size {
  SM,
  LG,
}

interface ServerEnvContext {
  isServer: boolean;
  size: Size;
}
const ServerEnvContext = createContext<ServerEnvContext>({
  isServer: RUNTIME_ENV === 'server',
  size: Size.LG,
});

export const Provider = ServerEnvContext.Provider;

export function useServerEnv() {
  const serverEnv = useContext(ServerEnvContext);
  return serverEnv;
}
